import React, { useContext } from 'react'
import {
    StyleButtonWrapper,
    StyledActionGroup,
    StyledDeleteAccount,
} from './DeleteAccount.styled'
import { Product, WebLink } from '@news-mono/web-common'
import { UserSettingsLink } from '../components/UserSettingsLink'
import { tokens } from '@news-mono/design-tokens'
import { UserSettingsButton } from '../components/UserSettingsButton'
import { MyAccountContext } from '../hooks/useMyAccountContext'
import { useProduct } from '../../__product'

const { utility } = tokens.thenightly.colors.palette
const { pinkThulite } = tokens.perthnow.colors.palette

export const DeleteAccount = () => {
    const { setScreen, setScreenSelected } = useContext(MyAccountContext)
    const product = useProduct()
    const isPn = product === Product.PerthNow
    const mastheadName = isPn ? 'PerthNow' : 'The Nightly'

    return (
        <StyledDeleteAccount>
            <p>
                Deleting your account with {mastheadName} will only delete the
                personal and other information you provided to us when you
                registered or updated this account such as your username, name
                and email address.
            </p>
            <p>
                Please note this does not extend to other accounts that you have
                registered or information you have shared with Seven West Media
                including when entering into a competition, or posting comments
                on our websites or social media pages/channels including on{' '}
                {mastheadName}, or in correspondence. For more information
                please see our{' '}
                <WebLink to={'https://sevenwestmedia.com.au/privacy-policies'}>
                    Privacy Policy
                </WebLink>
                .
            </p>
            <StyledActionGroup>
                <UserSettingsLink
                    color={isPn ? pinkThulite : utility.error.default}
                    onClick={() => setScreen('delete-account-acknowledge')}
                    disabled={false}
                    fontWeight={600}
                    underline={false}
                >
                    Delete my account
                </UserSettingsLink>
                <StyleButtonWrapper>
                    <UserSettingsButton
                        onClick={() => {
                            setScreen('manage-account')
                            setScreenSelected(true)
                        }}
                        btnType="primary"
                        disabled={false}
                    >
                        Cancel
                    </UserSettingsButton>
                </StyleButtonWrapper>
            </StyledActionGroup>
        </StyledDeleteAccount>
    )
}
